<script>
	import Dispatch from '../Dispatcher'
	import { faLockAlt, faWallet, faHandHoldingUsd, faPlay, faStop, faSolarSystem, faFire, faSparkles } from '@fortawesome/pro-solid-svg-icons'
	import { faSmile } from '@fortawesome/pro-regular-svg-icons'
	import Fa from 'svelte-fa'
  import { map, tap } from 'rxjs/operators';
  import { withLatestFrom } from 'rxjs/operators';
  import _ from 'lodash'
  import { render } from '../engines/renderer'
import { startWith } from 'rxjs/operators';
import Dot from './Dot.svelte'

	let mouseStart = 0

  const simulator = new Array(10).fill({}).map(e => new Array(10).fill({}))

  export let size

</script>

<div class='flex justify-center'>
  <div class='white'>
    {#each simulator as row, x}
      <div class='flex'>
        {#each row as dot, y}
          <Dot index={(x*10)+(y)} size={size}/>
          <!-- <div class='white' style={'height: 60px; width: 60px;'}>{!_.isNil(_.find($renderer, dot => dot.id === (x*10)+(y+1))) ? '.' : '' }</div> -->
        {/each}
      </div>
    {/each}
  </div>
</div>

<style>
</style>